import { setModalFromTemplateElement } from "../../../frontend/js/video-modal";

const init = () => {
    const buttons = [...document.querySelectorAll('button.lockable-link')];
    buttons.forEach(x => x.addEventListener("click", openModal));
}

const openModal = (e) => {
    const target = e.currentTarget;
    const templateId = target.dataset.template;
    setModalFromTemplateElement(templateId);
}

document.addEventListener("DOMContentLoaded", init)